import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-primary'>
        <div className="container-md pt-5">
            <div className="row justify-content-center align-items-center py-5">
            <div className="col-6 text-center">
                <small className='text-light'> Copyright &copy; 2022 Joshuah Boardman, All Rights Reserved</small>
            </div>

            </div>
        </div>
    </footer>
  )
}

export default Footer